import React, { useEffect, useState } from "react";
import "../../css_files/Master/SearchBoilerSeriesMaster.css";
import CloseForm from "./CloseForm";
import axios from "axios";
import { toast } from "react-toastify";
import getCookie from "../../api";
import Swal from "sweetalert2";
import AutoCompleteSearch from "./AutoCompleteSearch";
import axiosInstance from "../../api";
import LoadingScreen from "../Homepage/LoadingScreen";
import Select from "react-select";

function SearchBoilerSeriesMaster({
  setshowsearchform,
  setIds,
  setpagenumber,
  setReload,
  setSearch,
  reload,
  setBoilerSeriesId,
  setSubIds,
}) {
  const [options, setOptions] = useState([]);
  const [boilerSeriesOptions, setboilerSeriesOptions] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/BoilerSeries/GetBoilerSeriesDropdown`
      )
      .then((res) => {
        setboilerSeriesOptions(res.data);
      })
      .catch(console.log);

    axiosInstance
      .get(`${process.env.REACT_APP_API_URL}/api/v1/Boiler/GetBoilerDropdown`)
      .then((res) => {
        setOptions(res.data);
      })
      .catch(console.log);
  }, []);
  return (
    <div className="search-boiler-series-master-form">
      <h3>
        Search Boiler-Series Master By <br />
        Entering at least One Field
      </h3>
      <blockquote>
        <label>Id</label>
        <input
          type="number"
          placeholder="Enter Boiler Series Master Id (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setBoilerSeriesId(e.target.value);
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setBoilerSeriesId(e.target.value);
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>
      <blockquote>
        <label>Boiler Series Code</label>
        <Select
          isSearchable
          options={boilerSeriesOptions}
          onChange={(values) => {
            if (values) {
              setIds(values.map((x) => x.value));
            }
          }}
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          isMulti
          isClearable
          placeholder="Enter Boiler Series Code"
          menuPlacement="top"
          styles={{
            container: (base) => ({
              ...base,
              width: "100%",
            }),
            placeholder: (base) => ({
              ...base,
              color: "black",
            }),
            control: (base, state) => ({
              ...base,
              borderColor: "black",
              "&:hover": {
                borderColor: "black",
              },
              boxShadow: "none",
            }),
            singleValue: (base) => ({
              ...base,
              color: "black",
            }),
            dropdownIndicator: (base) => ({
              ...base,
              color: "black",
              "&:hover": {
                color: "black",
              },
            }),
            indicatorSeparator: (base) => ({
              ...base,
              backgroundColor: "black",
            }),
            noOptionsMessage: (base) => ({
              ...base,
              color: "black",
            }),
          }}
        />
      </blockquote>
      <blockquote>
        <label>Boiler Head</label>
        <Select
          isSearchable
          options={options}
          onChange={(values) => {
            if (values) setSubIds(values.map((x) => x.value));
          }}
          isMulti
          isClearable
          closeMenuOnSelect={false}
          hideSelectedOptions={false}
          placeholder="Select Boiler Head"
          menuPlacement="top"
          styles={{
            container: (base) => ({
              ...base,
              width: "100%",
            }),
            placeholder: (base) => ({
              ...base,
              color: "black",
            }),
            control: (base, state) => ({
              ...base,
              borderColor: "black",
              "&:hover": {
                borderColor: "black",
              },
              boxShadow: "none",
            }),
            singleValue: (base) => ({
              ...base,
              color: "black",
            }),
            dropdownIndicator: (base) => ({
              ...base,
              color: "black",
              "&:hover": {
                color: "black",
              },
            }),
            indicatorSeparator: (base) => ({
              ...base,
              backgroundColor: "black",
            }),
            noOptionsMessage: (base) => ({
              ...base,
              color: "black",
            }),
          }}
        />
      </blockquote>
      <blockquote>
        <label>Search</label>
        <input
          type="search"
          placeholder="Enter Search Keyword (Press Enter Key)"
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
          onInput={(e) => {
            if (e.target.value?.trim() === "") {
              setSearch(e.target.value?.trim());
              setReload(!reload);
              setpagenumber(1);
            }
          }}
        />
      </blockquote>

      <CloseForm
        close={(x) => {
          setshowsearchform(x);
          setIds([]);
          setBoilerSeriesId(null);
          setSearch("");
          setReload(!reload);
        }}
      />
    </div>
  );
}

export default SearchBoilerSeriesMaster;
